import React from 'react';
import { ActionButton, Flex } from '@adobe/react-spectrum';
import Redo from '@spectrum-icons/workflow/Redo';
import Undo from '@spectrum-icons/workflow/Undo';
import { HistoryActions } from 'app/stores/history/actions';
import { useAppDispatch } from 'app/stores/store';
import { Hover } from 'app/views/components/editor/platform/desktop/workspace/imageAnnotate/Hover';
import { StylePicker } from 'app/views/components/editor/platform/mobile/workspace/imageAnnotate/StylePicker';
import { useConnect } from 'app/views/hooks/useConnect';
import { analytics } from 'app/utils/analytics';
import { Interaction } from './Interaction';
import { ToolPicker } from './ToolPicker';
export const ImageAnnotate = () => {
    const dispatch = useAppDispatch();
    const { hasUndo, hasRedo } = useConnect(state => ({
        hasUndo: state.project.inPast > 0,
        hasRedo: state.project.inFuture > 0,
    }));
    const onUndo = () => {
        analytics({
            action: 'ProjectAction',
            label: 'undo',
        });
        dispatch(HistoryActions.undo());
    };
    const onRedo = () => {
        analytics({
            action: 'ProjectAction',
            label: 'redo',
        });
        dispatch(HistoryActions.redo());
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Hover, null),
        React.createElement(Interaction, null),
        React.createElement(Flex, { position: "absolute", left: "size-100", right: "size-100", bottom: "size-200", justifyContent: "space-around" },
            React.createElement(StylePicker, null),
            React.createElement(ActionButton, { onPress: onUndo, isDisabled: !hasUndo },
                React.createElement(Undo, null)),
            React.createElement(ActionButton, { onPress: onRedo, isDisabled: !hasRedo },
                React.createElement(Redo, null)),
            React.createElement(ToolPicker, null))));
};
